export function localDateTime(day, value, fallback = '00:00:00') {
  const parts = String(value || fallback).split(':');
  const time = [0, 1, 2].map(i => (parts[i] || '00').padStart(2, '0')).join(':');
  return new Date(`${day?.slice(0, 10)}T${time}`);
}

export function shortTime(value, fallback = '—') {
  if (!value) return fallback;
  const [hour, minute = '00'] = String(value).split(':');
  return `${hour.padStart(2, '0')}:${minute.padStart(2, '0')}`;
}

// Shared by Dispatch and Availability so both screens assess the full trip.
export function transferTimes(transfer) {
  const arrival = transfer.arrival_date?.slice(0, 10);
  const departure = transfer.departure_date?.slice(0, 10);
  const multiDay = arrival && departure && arrival !== departure;
  return `${multiDay ? departure + ' ' : ''}${shortTime(transfer.departure_time)}–${multiDay ? arrival + ' ' : ''}${shortTime(transfer.arrival_time)}`;
}

export function transferOnDay(transfer, day) {
  return transfer.departure_date <= day && (transfer.arrival_date || transfer.departure_date) >= day;
}

export function driverCandidate(transfer, worker, entries, assignments) {
  const required = (transfer.required_licences || '').split(',').map(x => x.trim().toUpperCase()).filter(Boolean);
  const licences = { AM: ['AM', 'B', 'D', 'DE'], B: ['B', 'D', 'DE'], D: ['D', 'DE'], DE: ['DE'] };
  const held = (worker.drivers_license || '').replace(/\s/g, '').toUpperCase();
  if (required.length && !required.some(r => (licences[r] || [r]).includes(held))) return null;
  const start = localDateTime(transfer.departure_date, transfer.departure_time);
  const end = localDateTime(transfer.arrival_date || transfer.departure_date, transfer.arrival_time, '23:59:59');
  if (!Number.isFinite(+start) || !Number.isFinite(+end) || end < start) return { worker, status: 'UNKNOWN', group: 'blocked', reason: 'Invalid transfer dates' };
  const states = [];
  const day = new Date(start); day.setHours(12, 0, 0, 0);
  const last = new Date(end); last.setHours(12, 0, 0, 0);
  while (day <= last) {
    const date = `${day.getFullYear()}-${String(day.getMonth() + 1).padStart(2, '0')}-${String(day.getDate()).padStart(2, '0')}`;
    states.push(entries.get(`${worker.account_id}-${date}`)?.availability_state || 'UNKNOWN');
    day.setDate(day.getDate() + 1);
  }
  const status = ['UNAVAILABLE', 'VACATION', 'UNKNOWN', 'STANDBY'].find(s => states.includes(s)) || 'AVAILABLE';
  const clash = assignments.find(item => item.account_id === worker.account_id
    && localDateTime(item.departure_date, item.departure_time) < end
    && localDateTime(item.arrival_date || item.departure_date, item.arrival_time, '23:59:59') > start);
  const blocked = clash || ['UNAVAILABLE', 'VACATION'].includes(status);
  const reason = clash ? `Busy ${shortTime(clash.departure_time)}–${shortTime(clash.arrival_time)}`
    : { UNAVAILABLE: 'Declared unavailable', VACATION: 'On vacation', UNKNOWN: 'No declaration', STANDBY: 'Standby' }[status];
  return { worker, status, reason, group: blocked ? 'blocked' : status === 'AVAILABLE' ? 'ready' : 'confirm' };
}
